<div class="icon-loading">
  <span class="po-icon po-icon-exclamation"></span>
</div>
<div class="po-md-12 po-text-center">
  <span>
    {{ message }}
  </span>
</div>